export const fr = {
  $vuetify: {
    // C
    close: 'Fermer',
    chooseOption: 'Choisir une option',

    // Q
    qrcodeSummary: 'Scannez le QR code avec votre smartphone pour voir le produit en réalité augmentée',

    // S
    seeInAR: 'Voir chez soi',

  },
}
